import React, { FunctionComponent } from "react";
import cx from "classnames";
import { MenuComponent } from "../menu/Menu.component";
import styles from "./Header.module.scss";

interface HeaderProps {
  title: string;
  logo: string;
}

export const HeaderComponent: FunctionComponent<HeaderProps> = (
  props: HeaderProps,
): React.JSX.Element => {
  return (
    <header>
      <div className={styles["header"]}>
        <div
          id="logo"
          className={cx(
            styles["header-logo-wrapper"],
            styles["outline-outward"],
          )}>
          <img alt="logo" className={styles["header-logo"]} src={props.logo} />
        </div>
        <div className={styles["header-title"]}>{props.title}</div>
        <MenuComponent />
      </div>
    </header>
  );
};
